export * from './merchant.component';
